import { Star } from 'lucide-react'
import { cn } from '@/lib/cn'

/**
 * Favouriting is independent of the verdict on every surface: a rejected item
 * can be starred, and a star is not an approval (docs/03-page-specs.md §4).
 * Keeping the two orthogonal is what stops "starred" quietly becoming a
 * second, undocumented gate.
 */
export function FavoriteToggle({
  favorite,
  onChange,
  className,
}: {
  favorite: boolean
  onChange: (next: boolean) => void
  className?: string
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={favorite}
      aria-label={favorite ? 'Remove from favorites' : 'Add to favorites'}
      onClick={(e) => {
        e.stopPropagation()
        onChange(!favorite)
      }}
      className={cn(
        'inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-[4px]',
        'transition-colors hover:bg-surface-sunk',
        favorite ? 'text-warn' : 'text-ink-faint',
        className,
      )}
    >
      <Star size={14} fill={favorite ? 'currentColor' : 'none'} aria-hidden />
    </button>
  )
}
